import { observer } from 'mobx-react-lite'
import { useStore } from '../../models'
import { StatusBar, StyleSheet, useWindowDimensions } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { DS } from '../../design-system'
import { useEffect } from 'react'
import { useRouter } from 'expo-router'
import { useIsEmbeddedSegment } from '@/hooks/useIsEmbeddedSegment'

const learned = ['How to play', 'Key Terminology', 'Hand Strength', 'Rounds', 'Decision Making and Strategy']

export const MyFirstGameWinScreen = observer(() => {
  const router = useRouter()
  const isEmbedded = useIsEmbeddedSegment()
  const {
    game: { resetFirstGame },
    analytics: { setEvent },
    session: { selectedDailyTask, updateDailyTaskStatus }
  } = useStore()

  const goToPractice = () => {
    setEvent('Practice Game Tapped', { source: 'First_G' })

    resetFirstGame()
    router.navigate('/game/new?simple=true')
  }

  const { height } = useWindowDimensions()
  const isSmallerDevice = height < 750

  useEffect(() => {
    if (selectedDailyTask) {
      updateDailyTaskStatus().then().catch()
    }
  }, [updateDailyTaskStatus, selectedDailyTask])

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle={'light-content'} />

      <DS.Frame style={styles.contentContainer}>
        <DS.Frame style={[styles.statsCardContainer, !isSmallerDevice ? { justifyContent: 'flex-start' } : {}]}>
          <DS.Frame gap="16" style={styles.statsCard}>
            <DS.Frame style={styles.header}>
              <DS.Icon name="Stars" size={88} />
            </DS.Frame>
            <DS.Frame gap="4" justifyContent="center" style={{ paddingTop: 48 }}>
              <DS.Text variant="Body Small/Regular" color="Global/White" textAlign="center">
                Good job out there.
              </DS.Text>
              <DS.Text variant="Heading 1/Medium" color="Global/White" textAlign="center">
                Keep practicing!
              </DS.Text>
            </DS.Frame>
            <DS.Frame style={{ height: 8 }}>
              <DS.Icon name="Separator" />
            </DS.Frame>
            <DS.Text variant="Body Large/Medium" color="Global/White">
              Basics learned today.
            </DS.Text>
            <DS.Frame>
              {learned.map((learn, index) => (
                <DS.Frame style={{ flexDirection: 'row', gap: 6, marginVertical: 2 }} key={`learn-basic-${index}`}>
                  <DS.Icon name="Check--enclosed" size={20} color="Global/Black" />
                  <DS.Text variant="Body Medium/Regular" color="Global/White" textAlign="center">
                    {learn}
                  </DS.Text>
                </DS.Frame>
              ))}
            </DS.Frame>
            <DS.Frame style={{ height: 8 }}>
              <DS.Icon name="Separator" />
            </DS.Frame>
            <DS.Frame style={{ paddingHorizontal: 24, paddingVertical: isSmallerDevice ? 4 : 6, gap: 12 }}>
              <DS.Button
                variant={'Large/Primary'}
                type={'On Dark'}
                onPress={() => {
                  setEvent('First Game Play Again Tapped')
                  resetFirstGame()
                }}
              >
                Play Again
              </DS.Button>
              {!isEmbedded && (
                <DS.Button variant={'Large/Secondary'} type={'On Light'} onPress={goToPractice}>
                  Try practice game
                </DS.Button>
              )}
            </DS.Frame>
          </DS.Frame>
        </DS.Frame>
      </DS.Frame>
    </SafeAreaView>
  )
})

const styles = StyleSheet.create({
  container: {
    height: '100%',
    width: '100%'
  },
  background: {
    position: 'absolute',
    height: '100%',
    width: '100%'
  },
  closeContainer: {
    backgroundColor: `${DS.palette['Global/Black']}50`,
    borderRadius: 40,
    padding: 12,
    alignSelf: 'flex-end'
  },
  statsCard: {
    borderWidth: 1,
    borderColor: `${DS.palette['Global/White']}24`,
    backgroundColor: `${DS.palette['Global/White']}24`,
    borderRadius: 16,
    marginTop: 24,
    padding: 16
  },
  statsCardContainer: {
    paddingHorizontal: 24,
    height: '100%'
  },
  contentContainer: {
    height: '100%',
    width: '100%',
    flex: 1
  },
  header: {
    position: 'absolute',
    width: '100%',
    alignItems: 'center',
    top: -24,
    left: 16
  },
  secondCardHeader: {
    height: 80,
    width: 80,
    position: 'absolute',
    alignSelf: 'center',
    backgroundColor: DS.palette['Global/White'],
    borderRadius: 40,
    top: -20,
    zIndex: 10
  },
  vsContainer: {
    padding: 16,
    borderRadius: 12,
    paddingTop: 40
  },
  blurCard: {
    position: 'absolute',
    borderRadius: 16,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  topNav: {
    paddingTop: 12,
    paddingHorizontal: 16
  },
  winRateContainer: {
    padding: 16,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12
  },
  biggestPotContainer: {
    marginLeft: 1,
    padding: 16,
    borderTopRightRadius: 12
  },
  pieChartSize: { height: 80, width: 80 },
  rankPositionContainer: { marginRight: 1, padding: 16, borderTopStartRadius: 12 }
})
